import {bindable, customElement, inject} from "aurelia-framework";

@customElement('two-decimal-render')
export class TwoDecimalRender
{
  @bindable() params;
  @bindable() cssClass = "ag-grid-cell-right";
  private value: any;

  constructor(element)
  {
  }
  
  bind(){
    this.value = this.params.value
  }

}


